export function winLocatioHash() {
    const target = window.location.hash;
    if ($(target).length) {
        const targetTop = $(target).offset().top;
        $("html, body").animate({scrollTop: targetTop}, 700);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/winLocatioHash.js